//
// Suggestions
// A view controller that is used by the AI Assist Widget to display an 'empty' state
// when there are no suggestions to show
//

define(function(require) {
  var ViewController = require('web-agent-framework/ViewController');

  var SuggestionEmptyViewController = ViewController.extend({
    ControllerName: 'SuggestionEmptyViewController',

    LPViewMap: {},

    initialize: function() {},

    events: function() {},

    render: function() {}
  });

  return SuggestionEmptyViewController;
});
